// Romanian-locale number formatter — single source for thousands-
// separator handling (`.` between groups) across the marketplace UI.
// Used by review counts on every salon-card / map-sidebar / InfoWindow
// surface, and ready for price totals / aggregate stats if they ever
// need the same treatment.
//
// The `Number(...)` coercion is intentional defence: if a value lands
// here as a string (e.g. Prisma's `Int` coming through a JSON parse
// boundary, or a hand-built test record), calling `.toLocaleString`
// directly on a String would return the original character-by-character
// string with no separator applied. Wrapping it in Number() forces the
// numeric formatter to run.
//
// Returns '0' for null / undefined / NaN so callers never have to
// guard for nullish review counts inline.
//
// Formatter is instantiated once at module scope so a marketplace render
// with ~50 salon cards reuses one Intl object instead of spinning up the
// locale-sensitive machinery per call. V8 caches per-locale internally
// these days, but the explicit cache is the documented Intl pattern and
// removes any dependency on engine-level memoization.
const roFormatter = new Intl.NumberFormat('ro-RO');

export function formatRoNumber(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0';
  return roFormatter.format(n);
}
